import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ResponseInfoStatusEnum } from '#common/enums/response-info-status.enum';
import { SessionTypeEnum } from '#common/enums/session-type.enum';
import { ToBackendRequestInfoNameEnum } from '#common/enums/to/to-backend-request-info-name.enum';
import type {
  ToBackendGetLlmModelsWithProviderRequestPayload,
  ToBackendGetLlmModelsWithProviderResponse
} from '#common/zod/to-backend/llm-models/get-llm-models-with-provider/get-llm-models-with-provider';
import { NavQuery } from '../queries/nav.query';
import { SessionModelsQuery } from '../queries/session-models.query';
import { ApiService } from '../services/api.service';

@Injectable({ providedIn: 'root' })
export class SessionModelsResolver {
  constructor(
    private apiService: ApiService,
    private sessionModelsQuery: SessionModelsQuery,
    private navQuery: NavQuery
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    routerStateSnapshot: RouterStateSnapshot
  ): Observable<boolean> {
    let nav: any;
    this.navQuery
      .select()
      .pipe(take(1))
      .subscribe(x => {
        nav = x;
      });

    let payload: ToBackendGetLlmModelsWithProviderRequestPayload = {
      projectId: nav.projectId,
      sessionTypes: [SessionTypeEnum.Explorer, SessionTypeEnum.Editor]
    };

    return this.apiService
      .req({
        pathInfoName:
          ToBackendRequestInfoNameEnum.ToBackendGetLlmModelsWithProvider,
        payload: payload
      })
      .pipe(
        map((resp: ToBackendGetLlmModelsWithProviderResponse) => {
          if (resp.info?.status === ResponseInfoStatusEnum.Ok) {
            this.sessionModelsQuery.update({
              modelsOpencode: resp.payload.modelsOpencode,
              modelsAi: resp.payload.modelsAi
            });

            return true;
          } else {
            return false;
          }
        })
      );
  }
}
